<template>
	<v-container fluid class="fill-height">
		<v-row align="center" justify="center">
			<v-col cols="12" sm="8" md="6">
				<v-card class="elevation-12">
					<v-card-title class="display-1 red darken-1 white--text">
						Tiempo de prueba expirado
						</v-card-title>
					<v-card-text>
						<v-row align="center" justify="center">
							<v-col cols="12" sm="4" class="text-center">
								<v-icon size="100" color="red darken-1">fas fa-calendar-times</v-icon>
							</v-col>
							<v-col cols="12" sm="8">
								<p class="text-center">Le informamos que el periodo de pruebas del sitio ha expirado y no puede hacerse uso del mismo hasta que se renueve la afiliación. Pedimos disculpas por las molestias ocasionadas.</p>
								<p class="body-1 text-center">Si usted es el administrador de <strong>{{this.sitio}}</strong> escribanos un correo a <a :href="href"  class="red--text">losandescoworking@gmail.com</a>o por el numero de telefono <strong>0424-2192367</strong> solicitando la información necesaria para concretar la afiliación.</p>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
	export default {
		name: 'prueba-terminada',
		created(){
			let cual = this.$route.params.num
			this.sitio = this.$sitios[cual-1]
		},
		data () {
			return {
				sitio:null,
				sitios: ['Los Andes Coworking', 'Sam Coworking','Margarita Coworking','VIMORCA']
			}
		},
		computed: {
			href: function () {
				let string = 'mailto:losandescoworking@gmail.com?subject='

				let encondeSubject = encodeURI('[Tech] Afiliación al sistema de coworking '+this.sitio)

				return string+encondeSubject
			}
		}
	}
</script>